// import React from "react";
// const CheckCircleIcon = () => (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 20 20"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <circle cx="10" cy="10" r="10" fill="#6C4EE3" />
//     <path
//       d="M5.5 10.2L8.6 13.3L14.5 7.4"
//       stroke="white"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// // export default CheckCircleIcon;
// const ProgramStep = ({ data }) => {
//   console.log(data, ".............")
//   if (!data) return null;

//   const {
//     step,
//     title,
//     description,
//     image,
//     imageAlt,
//     highlights = [],
//   } = data;

//   return (
//     <section className="w-full py-8 md:py-12">
//       <div className="container mx-auto px-4 md:px-8">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

//           {/* Image */}
//           <div>
//             <img
//               src={image}
//               alt={imageAlt || title}
//               className="w-full  rounded-[24px] object-cover"
//             />
//           </div>

//           {/* Content */}
//           <div className="max-w-xl">
//             <p
//               className="text-xs font-semibold uppercase tracking-[2px] mb-2"
//               style={{ color: "var(--primary-color)" }}
//             >
//               STEP {step}
//             </p>
//             <h2 className="ava-heading-md">
//               {title}
//             </h2>

//             <p className="ava-text-body">
//               {description}
//             </p>

//             <div className="mt-8 space-y-4">
//               {highlights.map((feature, index) => (
//                 <div
//                   key={index}
//                   className="flex items-center gap-3"
//                 >
//                   {/* <img
//                     src={feature.icon}
//                     alt=""
//                     className="w-5 h-5"
//                   /> */}
//                   <CheckCircleIcon />
//                   <span className="ava-text-body">
//                     {feature}
//                   </span>
//                 </div>
//               ))}
//             </div>

//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ProgramStep;
import React from "react";
// import ProgramStep from "./ProgramStep";

/*
 * Maps journey.steps -> a stack of ProgramStep sections,
 * alternating image-left/text-right and image-right/text-left
 * every other step (1st: image-left, 2nd: image-right, 3rd: image-left...).
 *
 * Usage: <ProgramJourney journey={program.journey} />
 */
const ProgramJourney = ({ journey }) => {
  if (!journey?.steps?.length) return null;

  return (
    <div className="w-full ">
      <div className="text-center">
        <h2 className="relative inline-block text-xl md:text-2xl font-medium ">
          Your Wellness Journey
        </h2>
      </div>
      {journey.steps.map((step, index) => (
        <ProgramStep
          key={step.id || step.step}
          data={step}
          reverse={index % 2 === 1}
        />
      ))}
      <div className="flex items-center justify-center mb-10">
      <button className="btn-primary">Enroll Now</button>
      </div>
    </div>
  );
};

export default ProgramJourney;

const CheckCircleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="10" fill="var(--primary-color)" />
    <path d="M5.5 10.2L8.6 13.3L14.5 7.4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ProgramStep = ({ data, reverse = false }) => {
  if (!data) return null;

  const {
    step,
    title,
    description,
    image,
    imageAlt,
    highlights = [],
  } = data;

  return (
    <section className="w-full py-8 md:py-6 px-2 md:px-6">
      <div className="container mx-auto px-4 md:px-10 lg:px-14">
        <div
          // className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center"
          className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center"
        >

          {/* Image — order flips based on `reverse` */}
          <div className={reverse ? "order-1 lg:order-2" : "order-1 lg:order-1"}>
            <div className="" style={{height:"300px"}}>
            <img
              src={image}
              alt={imageAlt || title}
              className=" w-full h-full rounded-[24px] object-cover"
            // style={{  maxWidth: "480px" }}
            />
            </div>
          </div>

          {/* Content — order flips based on `reverse` */}
          <div className={`max-w-xl ${reverse ? "order-2 lg:order-1" : "order-2 lg:order-2"}`}>
            <p
              // className="text-xs font-semibold uppercase tracking-[2px] mb-2"
              className="mb-2 ava-text-xs font-semibold "
              style={{ color: "var(--primary-color)" }}
            >
              STEP {step}
            </p>
            <h2 className="ava-heading-md">
              {title}
            </h2>

            <p className="ava-text-body">
              {description}
            </p>

            <div className="mt-8 space-y-4">
              {highlights.map((feature, index) => (
                <div key={index} className="flex items-center gap-3">
                  <CheckCircleIcon />
                  <span className="ava-text-body">
                    {feature}
                  </span>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

// export default ProgramStep;